export default __webpack_public_path__ + "static/media/ic-discord.da3ea4b2.svg";